export const getObjKey = (obj, k, defaultVal) => {
    if (typeof k === 'string') {
        k = k.split('.');
    }

    let p = k[0];

    if (typeof obj === 'undefined' || obj === null) {
        return defaultVal;
    }
    if (k.length > 1) {
        return getObjKey(obj[p], k.slice(1), defaultVal);
    } else {
        return (obj.hasOwnProperty(p)) ? obj[p] : defaultVal;
    }
};

export const objectToArray = (object) => {
    return Object
        .keys(object)
        .map((key) => object[key]);
};
